import React from 'react';
import Script from 'next/script';
import Head from 'next/head';

interface SEOProps {
  author?: string;
  sitename?: string;
  siteUrl?: string;
  siteNameUrl?: string;
  logopath?: string;
  title?: string;
  tag?: string;
  description?: string;
  image?: string;
  url?: string;
  linkedIn?: string;
  telephone?: string;
  address?: string;
  local?: string;
  postcode?: string;
  country?: string;
  latitude?: string;
  longitude?: string;
  updated?: string;
  published?: string;
  modified?: string;
  siteUrlPT?: string;
  urlPT?: string;
  urlENPT?: string;
}

const SEO: React.FC<SEOProps> = ({
  sitename = 'SEOptimist',
  siteUrl = 'https://seoptimist.co.uk',
  siteUrlPT = 'https://seoptimist.pt',
  logopath = 'https://seoptimist.co.uk/email-img/seoptimist-black.png',
  author = 'SEOptimist',
  linkedIn = 'https://www.linkedin.com/in/finlaysonj/',
  telephone = '+44 0744 139 7020',
  address = '9 Moreland St',
  local = 'London, United Kingdom',
  postcode = 'EC1V 8BE',
  country = 'UK',
  latitude = '51.529206652814715',
  longitude = '-0.09873897116400623',
  tag,
  image,
  title = '',
  description,
  url,
  urlPT,
  urlENPT,
  updated = '2022-12-12T19:57:40+00:00',
  published = '2022-12-12T19:57:40+00:00',
  modified = '2022-12-12T19:57:40+00:00'
}) => {
  const sentence = title.split(' ');
  for (var i = 0; i < sentence.length; i++) {
    sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
  }
  const titleCaps = sentence.join(' ');
  const canonicalUrl = url
    ? `${siteUrl}/${url.replace(/^\/+/, '')}`  // Remove leading slashes
    : siteUrl;

  return (
    <>
      <Head>
        <meta name="robots" content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large" />\
        <meta name="google-site-verification" content="B-43YtlLbhe_E2duJ5hogYutwdId35AX9ArCsxHsNvI" />
        <meta property="og:locale" content="en_GB" />
        <meta property="og:type" content="website" />
        <title>
          {sitename} | {titleCaps}
        </title>
        <meta name="description" content={description} />
        <meta property="og:title" content={`${sitename} - ${titleCaps}`} />
        <meta property="og:site_name" content={sitename} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:url" content={`${siteUrl}/${url}`} />
        <meta property="og:updated_time" content={updated} />
        <meta property="article:tag" content={tag} />
        <meta property="article:publisher" content={sitename} />
        <meta property="article:author" content={author} />
        <meta property="article:published_time" content={published} />
        <meta property="article:modified_time" content={modified} />
        <meta property="og:url" content={canonicalUrl} />

        <link rel="canonical" href={canonicalUrl} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${sitename} - ${titleCaps}`} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:label1" content="Written by" />
        <meta name="twitter:data1" content={author} />
        <meta name="twitter:label2" content="Time to read" />
        <meta name="twitter:data2" content="15 minutes" />
      </Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: title,
            description: description,
            url: canonicalUrl,
            // ... add any other structured data you need
          }),
        }}
      />
      {/* Visits are counted with the self-hosted Umami: no cookies, so no consent banner. Replaces GA4, Tag Manager, Google Ads tracking and CookieYes (2026-10-22). */}
      <Script
        defer
        src="https://analytics.seoptimist.co.uk/script.js"
        data-website-id="e582409e-1ad1-4bcb-aa47-ffcd45dd5cf9"
        data-domains="seoptimist.co.uk"
        strategy="afterInteractive"
      />

    </>


  );
};

export default SEO;
